import type { IconDefinition } from '../index.tsx';

export const iconSettings: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconSettings',
  icon: [
    16,
    16,
    [],
    '',
    'M9 0H7L6.44943 2.20228C5.9349 2.33954 5.44758 2.54347 4.9973 2.80426L3.05026 1.63604L1.63605 3.05025L2.80427 4.99728C2.54348 5.44757 2.33954 5.93489 2.20228 6.44943L0 7V9L2.20228 9.55057C2.33954 10.0651 2.54347 10.5524 2.80427 11.0027L1.63605 12.9497L3.05026 14.364L4.99729 13.1957C5.44757 13.4565 5.93489 13.6605 6.44943 13.7977L7 16H9L9.55057 13.7977C10.0651 13.6605 10.5524 13.4565 11.0027 13.1957L12.9498 14.364L14.364 12.9497L13.1957 11.0027C13.4565 10.5524 13.6605 10.0651 13.7977 9.55057L16 9V7L13.7977 6.44943C13.6605 5.9349 13.4565 5.44758 13.1957 4.9973L14.364 3.05025L12.9498 1.63603L11.0027 2.80426C10.5524 2.54347 10.0651 2.33954 9.55057 2.20228L9 0ZM8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z',
  ],
  fillRule: 'evenodd',
  clipRule: 'evenodd',
};
